import { render, staticRenderFns } from "./popup-guige-demo.vue?vue&type=template&id=d34512da&scoped=true"
import script from "./popup-guige-demo.vue?vue&type=script&lang=js"
export * from "./popup-guige-demo.vue?vue&type=script&lang=js"
import style0 from "./popup-guige-demo.vue?vue&type=style&index=0&id=d34512da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d34512da",
  null
  
)

export default component.exports